module App.Classes {
    export class CarInformation implements Interfaces.ICarInformation {
        customCarDescription: string;
        brand: string;
        type: string;
        constructionYear: number;
        fuelType: string;
        found: boolean;
        nextApkDate: Date;
        apkIsValid: boolean;
    }
}